module.exports = __webpack_public_path__ + "img/IMG_1829.dc38eaef.jpeg";